import {Routes, Route, Navigate} from 'react-router-dom'

import {PageLink, PageTitle} from '../../../../../_metronic/layout/core/PageData'
import {useIntl} from 'react-intl'
import {ServerGroupList} from './ServerGroupList'
import {ServerGroupForm} from './ServerGroupForm'

const ServerGroupRoutes = () => {
  const intl = useIntl()
  const breadcrumbs: Array<PageLink> = [
    {
      title: 'Arteco Insight',
      path: '',
      isSeparator: false,
      isActive: false,
      disableLink: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: intl.formatMessage({id: 'MENU.SYSTEM_SETTINGS'}),
      path: '',
      isSeparator: false,
      isActive: false,
      disableLink: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  const breadcrumbs_with_lista: Array<PageLink> = [
    {
      title: 'Arteco Insight',
      path: '',
      isSeparator: false,
      isActive: false,
      disableLink: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: intl.formatMessage({id: 'MENU.SYSTEM_SETTINGS'}),
      path: '',
      isSeparator: false,
      isActive: false,
      disableLink: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: intl.formatMessage({id: 'MENU.SYSTEM_SETTINGS.SERVER_GROUPS'}),
      path: '/system-settings/server-groups',
      isSeparator: false,
      isActive: false,
      disableLink: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  return (
    <Routes>
      <Route
        index
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs}>
              {intl.formatMessage({id: 'MENU.SYSTEM_SETTINGS.SERVER_GROUPS'})}
            </PageTitle>
            <ServerGroupList />
          </>
        }
      />
      <Route
        path='add'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs_with_lista}>
              {intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVER_GROUP.ADD'})}
            </PageTitle>
            <ServerGroupForm />
          </>
        }
      />
      <Route
        path='edit/:id'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs_with_lista}>
              {intl.formatMessage({id: 'SYSTEM_SETTINGS.SERVER_GROUP.EDIT'})}
            </PageTitle>
            <ServerGroupForm />
          </>
        }
      />
      <Route path='*' element={<Navigate to='/error/404' />} />
    </Routes>
  )
}
export {ServerGroupRoutes}
